<script setup lang="ts">
import { Draft, DraftType } from '@/dashboard/types/draft';
import Divider from '@/dashboard/vue/components/common/Divider.vue';

const props = defineProps<{
  draft: Draft;
}>();
const isMac = /Mac|iPhone|iPad/.test(navigator.platform);
</script>

<template>
  <div class="shadow-menu-s fixed bottom-[52px] right-[52px] w-auto min-w-[310px] rounded-16 bg-white px-[12px] pb-m pt-s dark:bg-gray-900">
    <p v-if="draft.draft_type === DraftType.image" class="text-caption-s mb-[21px] px-[12px] text-black dark:text-white">
      Tab = Hide / Show All <br />
      {{ isMac ? 'Option' : 'Alt' }} + C = Switch Comments <br />
      {{ isMac ? 'Cmd' : 'Ctrl' }} +/- = Zoom <br />
      Shift + Scroll = Scroll sideways<br />
      Space + Mouse = Pan view <br />
    </p>

    <p v-if="draft.draft_type === DraftType.video" class="text-caption-s mb-[21px] px-[12px] text-black dark:text-white">
      Tab = Hide / Unhide All <br />
      Space + Mouse = Pan view <br />
      {{ isMac ? 'Cmd' : 'Ctrl' }} + / - = Zoom <br />
      {{ isMac ? 'Cmd' : 'Ctrl' }} + Scroll = Zoom
    </p>

    <Divider class="divider-gray-450 dark:divider-gray-700"></Divider>

    <div class="flex justify-center pt-m">
      <a href="https://u24.gov.ua/" target="_blank">
        <svg xmlns="http://www.w3.org/2000/svg" width="131" height="13" viewBox="0 0 131 13" fill="none">
          <g clip-path="url(#clip0_3923_60647)">
            <path
              class="fill-black dark:fill-white"
              d="M38.6723 1.99744H45.2388V12.597H38.6723V1.99744ZM11.5695 6.47939C11.5695 7.99347 10.772 8.706 9.06793 8.706C7.36388 8.706 6.56546 7.99441 6.56546 6.47939V1.99744H0V6.73731C0 11.1738 2.37133 12.7482 9.06793 12.7482C15.7645 12.7482 18.1359 11.171 18.1359 6.73731V1.99744H11.5695V6.47939ZM45.9326 5.93482H51.4265V12.597H57.993V5.93482H63.4872V1.99744H45.9326V5.93482ZM31.3546 7.49437L26.2202 1.99744H18.9777V12.597H25.4563V7.10005L30.5863 12.597H37.8323V1.99744H31.3546V7.49437ZM114.355 4.23982C114.355 1.34802 111.911 0 106.762 0C101.209 0 98.8656 1.54471 98.8656 5.239H104.028C104.028 3.96705 104.882 3.51247 106.574 3.51247C108.222 3.51247 108.744 3.81582 108.744 4.28525C108.744 4.90594 108.556 4.90594 104.401 5.91997C99.8031 7.05552 98.3757 9.29698 98.3757 11.4623V12.5979H113.981V9.15687H104.853C105.404 8.61136 106.965 8.46014 110.422 7.76526C112.721 7.3125 114.355 6.47939 114.355 4.23982ZM64.1844 12.597H79.124V9.4352H70.4628V8.54178H76.6241V6.05543H70.4628V5.16201H79.1259V1.99744H64.1844V12.597ZM131 6.96462V10.5077H128.657V12.597H123.322V10.5077H114.514V6.93027L120.834 0.419344H128.658V6.96091L131 6.96462ZM123.321 3.48185L119.953 6.96462H123.321V3.48185ZM98.5908 7.30138C98.5908 10.8593 96.4501 12.6007 92.0387 12.6007H79.9634V1.99744H92.0387C96.4501 1.99744 98.5908 3.73883 98.5908 7.30138ZM92.184 7.30138C92.184 6.10457 91.547 5.54424 90.2168 5.54424H86.37V9.05762H90.2168C91.547 9.05392 92.184 8.49355 92.184 7.30138Z"
            />
          </g>
          <defs>
            <clipPath id="clip0_3923_60647">
              <rect width="131" height="13" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </a>
    </div>
  </div>
</template>
